import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemText,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { enabledReferenceFields, referenceFieldStringMap } from '../../utils/constants'

import type { GridVersionPayload } from 'honeygrid-types'
import type { DataSourceFieldMappings } from 'honeygrid-types/validators-and-types/DataSourceTypes'
import type { FC } from 'react'

interface TargetingFilterModalProps {
	open: boolean
	onClose: () => void
	onSave: (selectedKeys: string[]) => void
	targetingFilters: GridVersionPayload['targeting_filters']
	customDataKeys?: string[]
	fieldMappings?: DataSourceFieldMappings
}

//The ony prop is an array of the values that have the checkbox set as TRUE
export const TargetingFilterModal: FC<TargetingFilterModalProps> = ({
	onSave,
	open,
	onClose,
	targetingFilters,
	customDataKeys = [],
	fieldMappings,
}) => {
	const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({})

	useEffect(() => {
		if (!targetingFilters) {
			return
		}
		const entries = Object.entries(targetingFilters)
		const checkedItems = entries.reduce(
			(acc, entry) => {
				acc[entry[0]] = true
				return acc
			},
			{} as { [key: string]: boolean }
		)
		setCheckedItems(checkedItems)
	}, [targetingFilters])

	const handleOnSave = () => {
		const entries = Object.entries(checkedItems)
		const selectedEntries = entries.filter((entry) => entry[1])
		const selectedKeys = selectedEntries.map((entry) => entry[0])
		onSave(selectedKeys)
	}

	const handleCheckboxChange = (item: string) => {
		setCheckedItems((prevCheckedItems) => ({
			...prevCheckedItems,
			[item]: !prevCheckedItems[item],
		}))
	}

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle sx={{ m: 0, p: 2 }} id="dialog title" aria-label="Targeting rules">
				Select targeting filters
			</DialogTitle>
			<DialogContent dividers style={{ maxHeight: '290px', overflowY: 'scroll', padding: '0' }}>
				<List style={{ padding: 0 }}>
					{/* Custom data source fields */}
					{customDataKeys.map((item) => (
						<ListItem
							key={item}
							style={{
								display: 'flex',
								alignItems: 'center',
								borderBottom: '1px solid #3A2E2F1F',
							}}
						>
							<ListItemText primary={fieldMappings?.[item]?.friendlyName || item} />
							<Checkbox
								data-testid={`checkbox${item}`}
								checked={checkedItems[item] || false}
								onChange={() => handleCheckboxChange(item)}
							/>
						</ListItem>
					))}
					{/* Built-in reference fields */}
					{enabledReferenceFields.map((item) => (
						<ListItem
							key={referenceFieldStringMap[item]}
							style={{
								display: 'flex',
								alignItems: 'center',
								borderBottom: '1px solid #3A2E2F1F',
							}}
						>
							<ListItemText primary={referenceFieldStringMap[item]} />
							<Checkbox
								data-testid={`checkbox${item}`}
								checked={checkedItems[item] || false}
								onChange={() => handleCheckboxChange(item)}
							/>
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					variant="contained"
					onClick={() => {
						handleOnSave()
					}}
				>
					Apply
				</Button>
			</DialogActions>
		</Dialog>
	)
}
